const trimTrailingSlash = (url = "") => String(url).replace(/\/+$/, "");

export const API_BASE_URL = trimTrailingSlash(process.env.REACT_APP_AUTH_URL);
export const IMAGE_BASE_URL = trimTrailingSlash(process.env.REACT_APP_IMAGE_URL);

export const buildApiUrl = (path = "") => {
  const route = String(path).startsWith("/") ? path : `/${path}`;
  return `${API_BASE_URL}${route}`;
};
